import React, { Component } from "react";
import { ReactComponent as Plus } from "../assets/plus.svg";
import { ReactComponent as Minus } from "../assets/minus.svg";
import { connect } from "react-redux";
import { edit_quantity, remove_from_cart } from "../../../store/actions";

class DrawerQuantity extends Component {
  render() {
    const language = this.props.language;

    return (
      <div className="mx-auto w-25 mt-3">
        <div className="row">
          <div className="col p-0" style={{ width: 50, lineHeight: 2.5 }}>
            <Minus
              width={20}
              height={20}
              onClick={() => this.props.editQuantity(-this.props.increments)}
            />
          </div>
          <div className="col p-0">
            <h1
              style={{
                fontFamily: language == "english" ? "Quicksand" : "Cairo",
              }}
            >
              {this.props.quantity}
            </h1>
          </div>
          <div
            className="col p-0"
            style={{ width: 50, lineHeight: 2.5 }}
            onClick={() => this.props.editQuantity(this.props.increments)}
          >
            <Plus width={20} height={20} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    edit_quantity: (item, product_index, product, quantity, change) =>
      dispatch(edit_quantity(item, product_index, product, quantity, change)),
    remove_from_cart: (item_index, item) =>
      dispatch(remove_from_cart(item_index, item)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DrawerQuantity);
